import React, { useEffect, useState } from "react";
import { Col_12_8_6_4 } from "../../../../components/col/Col_12_8_6_4";
import LabelValor from "../../../../components/label/LabelValor";
import { Input, Modal, Select } from "antd";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";

export const AsesorServiciosGruas = () => {
  const [newValor, setNewValor] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();

  const { concesionariosServicio: c } = useSelector(
    (state) => state.concesionariosReducer
  );

  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => {
    setNewValor(c.asesorServiciosGruas || "");
    setOpenModal(true);
  };

  const handleOk = () => {
    dispatch(startUpdateServicio({ asesorServiciosGruas: newValor }, id));
    setOpenModal(false);
  };

  return (
    <>
      <Col_12_8_6_4>
        <LabelValor
          labelStyle={{ cursor: "pointer", textDecoration: "underline dotted" }}
          onClick={handleOpen}
          label="Analista"
          valor={c.asesorServiciosGruas?.charAt(0).toUpperCase() + c.asesorServiciosGruas?.slice(1)}
        />
      </Col_12_8_6_4>
      <Modal
        title="Analista"
        onCancel={() => setOpenModal(false)}
        onOk={handleOk}
        open={openModal}
      >
        <Select
          value={newValor}
          onChange={(value) => setNewValor(value)}
          placeholder="Seleccione analista"
          style={{ width: "100%" }}
          allowClear
          options={[
            { value: "Guadalupe Sanchez Hinojosa", label: "Guadalupe Sanchez Hinojosa" },
            { value: "Jorge Isaac Acoltzin Duarte", label: "Jorge Isaac Acoltzin Duarte" },
            { value: "Ruben Carrillo Sanchez", label: "Ruben Carrillo Sanchez" },
            { value: "Tania Malpica Vargas", label: "Tania Malpica Vargas" },
            { value: "Bruno Martinez Gomez", label: "Bruno Martinez Gomez" },
            { value: "Edgar Reyes Vazquez", label: "Edgar Reyes Vazquez" },
            { value: "Adrian Ramirez Apan", label: "Adrian Ramirez Apan" },
            { value: "Yuriko Matua Diaz", label: "Yuriko Matua Diaz" },
            { value: "Julieta Cano Garibay", label: "Julieta Cano Garibay" },
            { value: "Ana Lilia Agustin Velazquez", label: "Ana Lilia Agustin Velazquez" }
          ]}
        />
      </Modal>
    </>
  );
};